import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { RouteActions } from 'core';
import { Observable } from 'rxjs';

@Injectable()
export class AccessDeniedRouteGuard implements CanActivate {
    constructor(private routeActions: RouteActions, private router: Router) {}
    public canActivate(): Observable<boolean> | Promise<boolean> | boolean {
        if (!this.router.getCurrentNavigation().extras.state) {
            this.routeActions.goToRoot();
            return false;
        }
        return true;
    }
}
